"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ["M7 9H5a1 1 0 01-1-1L4.89.876A1 1 0 015.884 0h4.27a.847.847 0 01.793 1.144L9.125 6h2.05a.825.825 0 01.754 1.16L8.16 15.64A.606.606 0 017 15.394V9z"];
//# sourceMappingURL=lightning.js.map